import fetchFromApiServer from 'services/api';

export function fetchFundCharts(requestObject) {
  const url = `/fundinvestment-page/fund-investment-charts`;
  return fetchFromApiServer('PUT', url, requestObject);
}

export function fetchPortfolios(requestObject) {
  const url = `/fundinvestment-page/get-portfolio-list`;
  return fetchFromApiServer('GET', url, requestObject);
}

export function fetchPortfoliosInvestments(requestObject) {
  const url = `/fundinvestment-page/get-portfolio-investments`;
  return fetchFromApiServer('GET', url, requestObject);
}

export function fetchHighInterestInvestments(requestObject) {
  const url = `/fundinvestment-page/get-high-interest-investments`;
  return fetchFromApiServer('GET', url, requestObject);
}
